import React from 'react'
import {Container, Typography}  from "@mui/material"
import img from "../../Images/briefcase.png"
import styled, {keyframes}  from "styled-components"
import {FaFacebook, FaTwitter, FaLinkedin} from "react-icons/fa";
import {makeStyles} from "@mui/styles"
import {createTheme} from "@mui/material/styles"


const Spinner = keyframes`
from{
    -moz-transform: rotateY(0deg);
    -ms-transform: rotateY(0deg);
    transform:rotateY(0deg);
}
to {
    -moz-transform: rotateY(-360deg);
    -ms-transform: rotateY(-360deg);
    transform: rotateY(-360deg);
}
`

const theme = createTheme()

const useStyles = makeStyles({
    hero:{
        height:"auto",
        marginBottom:"4rem",
        // color:"#fff"
    },

    
})

const Image = styled.img`
width: 40%;
animation-name: ${Spinner};
animation-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
animation-iteration-count: infinite;
animation-duration: 30s;

:hover{
    animation-play-state: paused;
};

@media screen and (max-width:768px){
    width:100%;
}


`
const Heading = styled.div`
display:flex;
justify-content:space-evenly;
align-items:center;

@media screen and (max-width:768px){
    flex-direction:column;
    align-items:left;
}
`
const SocialIcons = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
width: 440px;
font-size: 1.2rem;
;

@media screen and (max-width: 768px){
    width: 320px;
}
`;

const SocialIconLink = styled.a`
font-size: 24px;
margin-top: 2rem;
padding: 10px;
color:#1B2821

@media screen and (max-width: 768px){
    margin-left: 1rem;
    
}

&:hover{
    color: #C3073F;
    transition: 0.3s ease-out
}
`

const Hero = () => {
    const classes = useStyles()
  return (
        <div className={classes.hero}>
    <Container maxWidth="lg">
        <Heading>
            <div data-aos="zoom-in-right">
        <p1>HI THERE, I'M</p1>
        {/* <Typography variant="h4" style={{color:"#E0BAC2"}}>Olukunle Olawuni</Typography> */}
        <Typography variant="h4">Olukunle Olawuni</Typography>
        <Typography variant="h6">I'm a Web and Software Developer from Lagos, Nigeria.</Typography>
        
        <SocialIcons>
                            
            <SocialIconLink href="https://www.facebook.com/olukunle.olawuni" target="_blank" aria-label="Facebook">
                 <FaFacebook/>
            </SocialIconLink>
    
            <SocialIconLink href="https://www.twitter.com/OlawuniOlukunl3" target="_blank" aria-label="Twitter">
                <FaTwitter/>
            </SocialIconLink>

            <SocialIconLink href="https://www.linkedin.com/in/olukunle-olawuni" target="_blank" aria-label="LinkedIn">
                <FaLinkedin/>
            </SocialIconLink>
            
            </SocialIcons>

        </div>

         
            <Image src={img} alt="briefcase" />
            
            
    
        </Heading>

    </Container>
    </div>
  )
}

export default Hero